import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login_card = _resolveComponent("login-card")!
  const _component_gpc_spinner_component = _resolveComponent("gpc-spinner-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_login_card),
    _createVNode(_component_gpc_spinner_component, { active: _ctx.showSpinner }, null, 8, ["active"])
  ], 64))
}